module.exports = "<app-i18n-toggle-translated-text text=$ctrl.field[$ctrl.mainLang] main-lang=$ctrl.mainLang> </app-i18n-toggle-translated-text> <textarea class=form-control name=\"{{ $ctrl.name }}\" ng-model=$ctrl.getSet ng-model-options=\"{getterSetter: true}\" rows=\"{{ $ctrl.rows || 6}}\" ng-required=\"{{ $ctrl.required }}\"></textarea> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/i18n/textarea_partial.html
// module id = 546
// module chunks = 0